<script>
import { interactionMixin, getUrlFromPath } from "src/modules/interactions_module.js";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";

export default {
  mixins: [interactionMixin, fandomBasicMixin],
  props: {
    // Placed temporary as a props, maybe it is better to place it in the globalState
    isIframe: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shareUrl: ""
    };
  },
  methods: {
    isContentVisibleToUser: Fandom.isContentVisibleToUser,
    providerIcon(provider) {
      const providerClass = Fandom.getProviderIcon(provider);
      const providerWeight = provider === "link" ? "far" : "fab";
      return [providerClass, providerWeight];
    },
    startShare(provider) {
      // We must copy the value to the clipboard here because if we go too deep in the call stack
      //   we lose the origin by a click event and so we can't copy anything to the clipboard
      if (["link"].includes(provider)) {
        this.copyToClipboard();
      }
      this.updateShareInteraction(this.containerContent, this.content, this.shareInteraction, provider, this.sharePath, this.isIframe);
    },
    isOnlyMobile(provider) {
      return ["whatsapp"].includes(provider);
    },
  },
  computed: {
    shareInteraction() {
      return get(this, "content.interaction", {});
    },
    shareProviders() {
      return get(this, "content.providers", "").split(",");
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`
      ];
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="container" stripe-share-component>
    <div class="row justify-content-center">
      <div :class="columnClasses">
        <div class="d-flex align-items-center">
          <p class="description mb-0 pr-5">{{ft("globals.share_on")}}</p>
          <div class="d-flex align-items-center justify-content-begin">
            <span class="cursor-pointer share-icon d-inline-flex align-items-center justify-content-center" v-for="(provider, index) in shareProviders" :key="index" :class="{'d-inline-block d-lg-none': isOnlyMobile(provider), 'mr-2 mr-lg-3': index + 1 < shareProviders.length}" @click="startShare(provider)">
              <i class="fa-lg" :class="providerIcon(provider)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

[stripe-share-component] {

  .share-icon {
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    transition: color $animation-time-fast;

    .fa-lg {
      font-size: 1rem;
    }

    &:hover,
    &:active,
    &:focus {
      color: $gray-700;
    }

    @include media-breakpoint-up(lg) {
      width: 3rem;
      height: 3rem;

      .fa-lg {
        font-size: 1.5rem;
      }
    }
  }
}

</style>